module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.2.1-rc.3-222.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.2.1-rc.3.md
// module id = 665
// module chunks = 323